import { ExtremwetterschutzSelbstbeteiligung } from '@ps20/bff-models';

export interface ExtremwetterschutzSelbstbeteiligungValues {
  zuersZone: number;
  selbstbeteiligungList: ExtremwetterschutzSelbstbeteiligung[];
}

export const ERDBEBEN_SELBSTBETEILIGUNG = 3000;

export const extremwetterschutzSelbstbeteiligungToBetrag = (
  selbstbeteiligung: ExtremwetterschutzSelbstbeteiligung,
): number | null => {
  if (!selbstbeteiligung) {
    return null;
  }
  const betrag = Number(selbstbeteiligung.replace('SELBSTBETEILIGUNG_', ''));
  return Number.isNaN(betrag) ? null : betrag;
};
